export default __webpack_public_path__ + "static/media/no_jobs.485865f7.svg";